//Funcion para cambiar la fecha de string a timeStamp
export const stringTo_timeStamp = (date) => {
    if (!date) return null;
    // console.log(date);
    const [year, month, day] = date.split("-");
    return new Date(year, month - 1, day);
  };